<template>
  <div id="div2" style="text-align: left; height: 100%; width: 100%">
    <div style="margin-bottom: 0px; margin-left: 10px; font-weight: bold">
      <Button @click="setPage">轨迹数据</Button>
      <Button @click="fillter">停车数据</Button>
      <span>总里程:{{ allLength }}公里，</span>
      <span>总时长:{{ allTime }}</span>
    </div>
    <div style="clear: both"></div>
    <lyTable :height="height - 110" :columns="columns2" :data="historyData" highlight-row @tr="rowData" ref="lytable">
      <template slot-scope="{ row, index }" slot="address">
        <a v-if="utils.isEmpty(row.address)" @click="jiexi(row, index)">解析当前地址</a>
        <span v-else>{{ row.address }}</span>
      </template>
    </lyTable>

    <div id="mypage">
      <Button @click="addExportTask" type="primary" :disabled='total == 0'>导出数据</Button>
      <Button @click="openyuanshi">原始数据</Button>
      <Button @click="jiexis">批量解析地址</Button>
      <div>
        <Page :current="1" :total="total" :page-size="pageSize" :page-size-opts="[1000, 2000, 3000, 5000]" show-total
          show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <exportLocus ref="exportLocus"></exportLocus>
    <Modal title="原始数据分析" v-model="modalYuanshi" footer-hide fullscreen>
      <yuanshi :scan="true" ref="yuanshi"></yuanshi>
    </Modal>
  </div>
</template>
<script>
import Direction from "../common/Direction.vue";
import exportLocus from "./export.vue";
import yuanshi from "../dataAnalyse/history.vue";
var jindu;
export default {
  props: ["mapData", "height"],
  components: { Direction, exportLocus, yuanshi },
  data() {
    return {
      tableHeight: 0,
      fresh: false,
      modal: false,
      modalYuanshi: false,
      isFenxi: false, //是否分析模式
      columns2: [
        {
          type: "index",
          width: 70,
          align: "center",
          fixed: "left",
        },
        {
          title: "车牌号",
          key: "carNo",
          width: 100,
          tooltip: true,
        },
        {
          title: "北斗时间",
          key: "gpsTime1",
          width: 130,
          tooltip: true,
        },

        {
          title: "位置地址",
          slot: "address",
          align: "left",
          width: 300,
          tooltip: true,
        },
        {
          title: "停车时长",
          key: "parkDuration1",
          width: 100,
          tooltip: true,
        },
        {
          title: "开始停车",
          key: "startParkTime",
          width: 130,
          tooltip: true,
        },
        {
          title: "结束停车",
          key: "endParkTime",
          width: 130,
          tooltip: true,
        },
        {
          title: "绝对里程/km",
          key: "mileage",
          align: "left",
          width: 70,
          tooltip: true,
        },
        {
          title: "相对里程/km",
          key: "mileage1",
          align: "left",
          width: 70,
          tooltip: true,
        },
        {
          title: "速度/km/h",
          key: "speed",
          align: "left",
          tooltip: true,
        },
        {
          title: "发动机",
          key: "accStatus1",
          align: "left",
        },
        {
          title: "信号",
          key: "flag1",
          align: "left",
          tooltip: true,
        },
        {
          title: "事件报告",
          key: "eventDesc",
          width: 200,
          tooltip: true,
        },
        {
          title: "上报时间",
          key: "recordTime1",
          width: 130,
          tooltip: true,
        },
        {
          title: "油量电阻值",
          key: "oil",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "方向度数",
          key: "directionDegree",
          align: "left",
          minWidth: 70,
          maxWidth: 130,
          tooltip: true,
        },
        {
          title: "设备号",
          key: "deviceNo",
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "司机从业资格证",
          key: "dqcNo",
          minWidth: 100,
          maxWidth: 200,
          tooltip: true,
        },

        {
          title: "高德经度(GCJ-02)",
          key: "returnX",
          minWidth: 160,
          maxWidth: 200,
        },
        {
          title: "高德纬度(GCJ-02)",
          key: "returnY",
          minWidth: 160,
          maxWidth: 200,
        },
        {
          title: "原始经度(WGS-84)",
          key: "orgX",
          minWidth: 160,
          maxWidth: 200,
        },
        {
          title: "原始纬度(WGS-84)",
          key: "orgY",
          minWidth: 160,
          maxWidth: 200,
        },
      ],
      title: "",
      tableDate: [], //分页前
      historyData: [], //分页后
      total: 0,
      tableDatedaochu: [],
      pageNumber: 1,
      pageSize: 1000, //每页数量
      select: {},
      exportTaskPro: 0, //任务进度
      taskId: "",
      finish: false,
      allLength: 0,
      allTime: 0,
      tt: "车辆",
    };
  },
  methods: {
    //当前行的数据
    rowData(data) {
      this.$emit("drawPoint", data);
    },
    rePoint(v) {
      this.$refs.lytable.scroll(v.pointIndex);
    },
    getHistory(data, x) {
      this.select = x; //原始轨迹用到
      this.tableDate = data;
      this.total = data.length;
      if (this.total == 0) {
        return;
      }

      this.allLength = (
        data[data.length - 1].mileage - data[0].mileage
      ).toFixed(2);

      var tt = (data[data.length - 1].gpsTime - data[0].gpsTime) / 1000;
      this.allTime = this.utils.duration(tt);
      this.setPage();
    },
    setPage() {
      this.historyData = this.utils.page(
        this.pageNumber,
        this.pageSize,
        this.tableDate
      );
      //this.jiexis();
    },
    fillter() {
      var data = this.tableDate;
      //console.log(data);

      var m = data.filter(function (item) {
        return item.parkDuration > 1;
      });
      this.historyData = m;
      console.log(m);
    },
    //页码切换时触发
    changePage(x) {
      this.pageNumber = x;
      this.setPage();
      //this.getHistory(this.select);
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.setPage();
      //his.getHistory(this.select);
    },
    addExportTask() {
      //应该去外面读取参数，历史设计缺陷，必须先请求才能导出
      this.select.tt = this.tt;
      this.select.val = 1;
      this.$refs.exportLocus.reachData(this.select);
    },
    openyuanshi() {
      //应该去外面读取参数，历史设计缺陷，必须先请求才能导出
      this.modalYuanshi = true;
      this.select.bind = this.select.carNo;
      this.select.tt = this.tt;
      this.select.val = 2;
      this.$refs.yuanshi.reach(this.select);
    },
    jiexi(row, index) {
      //row.address = 12345677;
      var pointList = [{ x: row.orgX, y: row.orgY }];
      this.utils.jiexi(pointList).then((data) => {
        for (let i = 0; i < data.length; i++) {
          row.address = data[i].address;
        }
      });
      //console.log(this.historyData[1].address);
      //console.log(this.historyData[2].address);
    },
    jiexis(row, index) {
      //row.address = 12345677;
      var h = this.historyData;
      
      var pointList = [];
      for (let i = 0; i < h.length; i++) {
        pointList.push({ x: h[i].orgX, y: h[i].orgY })

      }


      this.utils.jiexi(pointList).then((data) => {
        for (let i = 0; i < data.length; i++) {
          h[i].address = data[i].address;
          
        }
      });
      //console.log(this.historyData[1].address);
      //console.log(this.historyData[2].address);
    },
  },
  watch: {
    height(v) {
      this.tableHeight = v;
    },
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/locus/listAll.vue